import { useState } from 'react'
import {  Link, useParams } from "react-router-dom";

import { IoMdArrowDropleft } from "react-icons/io";

export default function listCats({ data }) {
    
    const params = useParams();
    let ckSub = data?.filter(r => r?._id == params?.id);
    let loopData = data?.filter(r => r?.parent?.val == ckSub[0]?.parent?.val);
    
    
    
    return (
        <ul className='cat'>

            {loopData?.map((v, k) => {

                let subCats = data?.filter(r => r?.parent?.val == v?._id);
                return (
                    <li key={k} className={`mainCat ${params?.id == v?._id ? "open" : "null"}`}>
                        <Link className={v?._id == params?.id ? `checked` : 'none'} to={`/cat/${v?._id}`}><span><IoMdArrowDropleft /> {v?.name}</span> {subCats?.length ? <b>{subCats?.length}</b>: false}</Link>

                        {/* {ckSub?.length ?
                        <ul>
                            {ckSub?.map((v2, k2) => {
                                return (
                                    <li key={k2} className='mainSubCat'>
                                        <Link className={v2?._id == params?.id ? `checked` : 'none'} to={`/cat/${v2?._id}`}><IoMdArrowDropleft /> {v2?.name}</Link>
                                    </li>
                                );
                            })}
                            
                        </ul>: false} */}
                    </li>
                );
                
            })}
            

        </ul>

    )
}
